import { useEffect, useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import logo from "../../Images/logo.png";
import Headerbggradient from "../../Images/gradient-effect-header-HomePg.png";

const Header = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const [openNave, setOpenNav] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const isContactPage =
    location.pathname === "/contact" ||
    location.pathname === "/industries-we-serve" ||
    location.pathname === "/events-conference" ||
    location.pathname === "/research-development" ||
    location.pathname === "/invesment-opportunities";

  const contactBtnClass = isContactPage
    ? "text-[#B8914A] border-[#B8914A] hover:text-[#9d7739] hover:border-[#9d7739]"
    : "text-black border-gray-500";

  return (
    <div className="navigation">
      <nav
        className={`fixed w-full z-[100] top-0 left-0 transition-all duration-300 ${
          scrolled && window.innerWidth >= 1024
            ? "backdrop-blur-lg bg-white/30"
            : ""
        }`}
        style={{
          background: window.innerWidth >= 1024 ? "transparent" : "transparent",
          backgroundImage:
            window.innerWidth >= 1024 ? `url(${Headerbggradient})` : "none",
          backgroundSize: window.innerWidth >= 1024 ? "cover" : "auto",
          backgroundPosition:
            window.innerWidth >= 1024 ? "center center" : "initial",
          backgroundRepeat: window.innerWidth >= 1024 ? "no-repeat" : "initial",
        }}
      >
        <div className="max-w-screen-2xl flex flex-wrap items-center justify-between mx-auto p-4">
          {/* Mobile Layout with Gradient Background */}
          <div
            className="flex items-center justify-between w-full lg:hidden p-4 rounded-lg"
            style={{
              background:
                "linear-gradient(to right, #423e3e 0%, #090909 50%, #423e3e 100%)",
            }}
          >
            {/* Hamburger Menu - Left */}
            <button
              type="button"
              className="inline-flex items-center p-2 w-10 h-10 justify-center text-[#C99C48] rounded-lg hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-200"
              onClick={() => {
                setOpenNav((prev) => !prev);
              }}
            >
              <span className="sr-only">Open main menu</span>
              <svg
                className="w-6 h-6"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 17 14"
              >
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M1 1h15M1 7h15M1 13h15"
                />
              </svg>
            </button>

            {/* Logo - Center */}
            <NavLink to="/home" className="flex items-center">
              <img src={logo} className="h-12" alt="Logo" />
            </NavLink>

            {/* Search/User Icon - Right */}
            <button
              type="button"
              className="inline-flex items-center p-2 w-10 h-10 justify-center text-[#C99C48] rounded-lg hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-200"
              onClick={() => {
                navigate("/contact");
              }}
            >
              <span className="sr-only">Contact</span>
              <svg
                className="w-6 h-6"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M3 5a2 2 0 012-2h2l2 5-2 2a16 16 0 006 6l2-2 5 2v2a2 2 0 01-2 2h-1c-8 0-14-6-14-14V5z"
                />
              </svg>
            </button>
          </div>

          {/* Desktop Layout */}
          <div className="hidden flex-1 lg:flex gap-6 lg:flex-row justify-between items-center flex-col">
            <NavLink to="/home" className="flex items-center">
              <img src={logo} className="h-14 mr-0" alt=" Logo" />
            </NavLink>

            <div className="items-center justify-between w-full lg:flex lg:w-auto">
              <ul className="flex flex-col p-4 lg:p-0 mt-4 lg:text-[16px] md:text-sm font-medium border border-gray-100 rounded-lg bg-gray-50 lg:flex-row lg:gap-3 lg:mt-0 lg:border-0 lg:bg-transparent">
                <li>
                  <NavLink
                    to="/home"
                    style={({ isActive }) => ({
                      color: isActive ? "#B8914A" : "current",
                    })}
                    aria-current="page"
                  >
                    Home
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/about-us"
                    style={({ isActive }) => ({
                      color: isActive ? "#B8914A" : "current",
                    })}
                  >
                    About Us
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/services"
                    style={({ isActive }) => ({
                      color: isActive ? "#B8914A" : "current",
                    })}
                  >
                    Services
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/industries-we-serve"
                    style={({ isActive }) => ({
                      color: isActive ? "#B8914A" : "current",
                    })}
                  >
                    Industries We Serve
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/invesment-opportunities"
                    style={({ isActive }) => ({
                      color: isActive ? "#B8914A" : "current",
                    })}
                  >
                    Investment Opportunities
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/research-development"
                    style={({ isActive }) => ({
                      color: isActive ? "#B8914A" : "current",
                    })}
                  >
                    Research & development
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/events-conference"
                    style={({ isActive }) => ({
                      color: isActive ? "#B8914A" : "current",
                    })}
                  >
                    Events & conferences
                  </NavLink>
                </li>
              </ul>
            </div>
            <NavLink to="/contact" className="nav-NavLink">
              <button
                type="button"
                className={`bg-transparent px-5 py-1 rounded-2xl border-2 border-solid transition-all duration-300 ${contactBtnClass}`}
              >
                Contact
              </button>
            </NavLink>
          </div>

          {/* Mobile Menu Dropdown */}
          {openNave && (
            <div className="lg:hidden w-full mt-4">
              <ul
                className="flex flex-col items-center p-6 font-medium rounded-lg text-white space-y-4"
                style={{
                  background:
                    "linear-gradient(to right, #423e3e 0%, #090909 50%, #423e3e 100%)",
                }}
              >
                <li>
                  <NavLink
                    to="/home"
                    className="text-white hover:text-[#C99C48] transition-colors duration-300 text-lg"
                    onClick={() => setOpenNav(false)}
                    style={({ isActive }) => ({
                      color: isActive ? "#B8914A" : "current",
                    })}
                  >
                    Home
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/about-us"
                    className="text-white hover:text-[#C99C48] transition-colors duration-300 text-lg"
                    onClick={() => setOpenNav(false)}
                    style={({ isActive }) => ({
                      color: isActive ? "#B8914A" : "current",
                    })}
                  >
                    About Us
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/services"
                    className="text-white hover:text-[#C99C48] transition-colors duration-300 text-lg"
                    onClick={() => setOpenNav(false)}
                    style={({ isActive }) => ({
                      color: isActive ? "#B8914A" : "current",
                    })}
                  >
                    Services
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/industries-we-serve"
                    className="text-white hover:text-[#C99C48] transition-colors duration-300 text-lg"
                    onClick={() => setOpenNav(false)}
                    style={({ isActive }) => ({
                      color: isActive ? "#B8914A" : "current",
                    })}
                  >
                    Industries We Serve
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/invesment-opportunities"
                    className="text-white hover:text-[#C99C48] transition-colors duration-300 text-lg"
                    onClick={() => setOpenNav(false)}
                    style={({ isActive }) => ({
                      color: isActive ? "#B8914A" : "current",
                    })}
                  >
                    Investment Opportunities
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/research-development"
                    className="text-white hover:text-[#C99C48] transition-colors duration-300 text-lg"
                    onClick={() => setOpenNav(false)}
                    style={({ isActive }) => ({
                      color: isActive ? "#B8914A" : "current",
                    })}
                  >
                    Research & development
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/events-conference"
                    className="text-white hover:text-[#C99C48] transition-colors duration-300 text-lg"
                    onClick={() => setOpenNav(false)}
                    style={({ isActive }) => ({
                      color: isActive ? "#B8914A" : "current",
                    })}
                  >
                    Events & conferences
                  </NavLink>
                </li>
                <li className="mt-6">
                  <NavLink
                    to="/contact"
                    className="bg-transparent px-8 py-2 rounded-full border-2 border-[#C99C48] text-[#C99C48] hover:bg-[#C99C48] hover:text-black transition-all duration-300 text-lg"
                    onClick={() => setOpenNav(false)}
                    style={({ isActive }) => ({
                      color: isActive ? "#B8914A" : "current",
                    })}
                  >
                    Contact Us
                  </NavLink>
                </li>
              </ul>
            </div>
          )}
        </div>
      </nav>

      {/* Empty spacer to keep content below the fixed header */}
      <div className="h-20 bg-transparent mt-[-5rem]"></div>
    </div>
  );
};

export default Header;
